module.exports = __webpack_public_path__ + "img/4c.1bd4e0aa.png";